<p-table [columns]="cols" [value]="data" [tableStyle]="tableStyle" styleClass="p-datatable-gridlines">
  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of columns; track col.index) {
      <th>
        {{ col.header }}
      </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr>
      @for (col of columns; track col.index) {
      <td>
        @if (col.field == 'majorTitle') {
        <ng-container>
          {{ rowData[col.field] }}
          @if (rowData.online == 1) {
          <app-badge class="pl-2" [value]="'Online'" [severity]="'warning'">
          </app-badge>
          }
          @if (rowData.inPerson == 1) {
          <app-badge class="pl-2" [value]="'In-Person'" [severity]="'info'">
          </app-badge>
          }

          @if (rowData.hybrid == 1) {
          <app-badge class="pl-2" [value]="'Hybrid'" [severity]="'success'">
          </app-badge>
          }
        </ng-container>
        } @else if (col.field == 'campaign_name') {
        @if (rowData.campaign_name == null) {
        <ng-container><a>
            Non-Paid Performance
          </a></ng-container>
        } @else {

        <ng-container>

          @if(!col.disableClick){
          <a class="text-blue-900 cursor-pointer" (click)="onLinkClick(rowData['id'])">{{ rowData[col.field] }}</a>
          } @else {
          <a>{{ rowData[col.field] }}</a>
          }
        </ng-container>
        }
        } @else if (col.field == 'cstatus') {
        @if(rowData.cstatus == 'no'){
        <ng-container>
          <app-chip [label]="'Inactive'" [color]="'error'"></app-chip>
        </ng-container>
        } @else {
        <ng-container>
          <app-chip [label]="'Active'" [color]="'success'"></app-chip>
        </ng-container>
        }

        } @else if(col.field == 'editDeleteRecords') {
        <ng-container>
          <div class="flex gap-4 justify-center">
            <app-button [label]="''" [startIcon]="'pi pi-file-edit'" [variant]="'text'"
              (sendClick)="onRecordUpdate(rowData['id'], 'edit')"></app-button>


            <app-button [severity]="'danger'" [label]="''" [startIcon]="'pi pi-trash'" [variant]="'text'"
              (sendClick)="onRecordUpdate(rowData['id'], 'delete')"></app-button>


          </div>
        </ng-container>
        }


        @else {
        <ng-container>
          @if (col?.pipe == 'currency') {
          {{
          rowData[col.field] == 0
          ? ' '
          : (rowData[col.field] | currency)
          }}
          } @else if (col.pipe == 'decimal') {
          {{
          rowData[col.field] == 0
          ? ' '
          : (rowData[col.field] | number: '1.2-2')
          }}
          } @else if (col.pipe == 'date') {
          {{
          rowData[col.field] == ''
          ? ' '
          : (rowData[col.field] | date: 'MM/dd/yyyy')
          }}
          } @else if (col.pipe == 'special-date') {
          {{
          rowData[col.field] == ''
          ? ' '
          : (rowData[col.field] | date: 'MM/dd/yyyy' : '+0430')
          }}
          } @else {
          {{ rowData[col.field] }}
          }
        </ng-container>
        }
      </td>
      }
    </tr>
  </ng-template>
</p-table>

@if (showCustomHeader) {
<ng-container>
  <p-table [columns]="[]" [value]="[]" [tableStyle]="tableStyle" styleClass="p-datatable-gridlines">
    <ng-template pTemplate="header">
      <tr>
        <th colspan="1">{{ customHeader }}</th>
      </tr>
    </ng-template>
    <!-- No body template for the custom header as it has no columns -->
  </p-table>
</ng-container>
}